/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathSec = createReactComponent("outline", "math-sec", "IconMathSec", [["path", { "d": "M3 15c.345 .6 1.258 1 2 1a2 2 0 1 0 0 -4a2 2 0 1 1 0 -4c.746 0 1.656 .394 2 1", "key": "svg-0" }], ["path", { "d": "M21 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-1" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-2" }], ["path", { "d": "M10 12h2.5", "key": "svg-3" }]]);

export { IconMathSec as default };
//# sourceMappingURL=IconMathSec.mjs.map
